import { baseForPdf } from '../../apiClients';
import { getLocalUserId } from '../../../components/shared/getToken';
import { Endpoints } from '../../../network';

export interface RecentlyViewedProduct {
  _id: string;
  productId: string | number;
  productType: 'book' | 'course' | 'bundle';
  title: string;
  slug: string;
  coverImage: string;
  main_price?: number;
  stroked_price?: number;
  author_name?: string;
  type?: string;
  isFree?: boolean;
  bookCount?: number;
  courseCount?: number;
}

export const addToRecentlyViewedProduct = async (
  productId: string | number,
  productType: 'book' | 'course' | 'bundle',
  zl_uid?: string,
) => {
  try {
    const localUserId = await getLocalUserId();

    const response = await baseForPdf.post(`${Endpoints.recentlyViewedProducts}`, {
      productId,
      productType,
      tempUserId: localUserId,
      ...(zl_uid && { zl_uid }),
    });

    return response?.data;
  } catch {
    return null;
  }
};

export const getRecentlyViewedProductsApi = async ({
  page,
  keyword,
  limit,
  zl_uid,
  tempUserId,
}: {
  page: string;
  keyword?: string;
  limit?: string;
  zl_uid?: string;
  tempUserId: string;
}) => {
  const queryParams = new URLSearchParams({
    page,
    tempUserId,
    ...(keyword !== undefined && { keyword: keyword }),
    ...(limit !== undefined && { limit: limit }),
    ...(zl_uid !== undefined && { zl_uid }),
  });
  const urlWithQuery = `${Endpoints.recentlyViewedProducts}?${queryParams}`;

  const response = await baseForPdf.get(urlWithQuery);
  return response?.data?.data;
};
